export const WalletTransactionsLocale = {
  en: {
    'bread-crump-parent': 'Reports',
    'bread-crump-current': 'Agent wallet',
    'page-title': 'Agent wallet',
    'page-subtitle':
      'Only Wallet Admins can view and edit wallet settings for agents using the CRM/MyLead app.',
    'minutes-used': 'Minutes Used',
    'balance-charged': 'Balance Charged',
    'remaining-balance': 'Remaining Balance',
    'active-agents': 'Active Agents',
    'transaction-type': 'Transaction Type',
    'transaction-created': 'Transaction Created',
    'branch-name': 'Branch Name',
    'team-leader': 'Team Leader',
    agents: 'Agents',
  },
  ar: {
    'bread-crump-parent': 'التقارير',
    'bread-crump-current': 'محفظة الوكيل',
    'page-title': 'محفظة الوكيل',
    'page-subtitle':
      'يمكن للمسؤولين المحفظة فقط عرض وتحديث اعدادات المحفظة للوكيلات المستخدمة في التطبيق CRM/MyLead.',
    'minutes-used': 'الدقائق المستخدمة',
    'balance-charged': 'الرصيد المشحون',
    'remaining-balance': 'الرصيد المتبقي',
    'active-agents': 'الوكلاء النشطون',
    'transaction-type': 'نوع المعاملة',
    'transaction-created': 'تم إنشاء المعاملة',
    'branch-name': 'اسم الفرع',
    'team-leader': 'قائد الفريق',
    agents: 'الوكلاء',
  },
};

export const WalletTransactionsPath = 'WalletTransactionsView';
